import {
  TGetPendingProductContractReqDto,
  TGetPendingProductContractResDto,
} from "@/api/services/admin/product-contract/dtos/get-pending-product-contract.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";

export const getPendingProductContractApi = async (req: TGetPendingProductContractReqDto): Promise<TGetPendingProductContractResDto> => {
  const url = createUrlWithParams("/product-contracts/pending", req);
  const rs = await clientApi.get<TGetPendingProductContractResDto>(url);
  return rs.data;
};

/**
 * Resolves the pending product contract staged by irohana-center for a handoff `token`
 * (from the `contract-token` cookie). Disabled until a token is present. Used by the
 * organization create page to obtain the center `organizationId` + `productContractId`.
 */
export const usePendingProductContract = (token?: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_CONTRACT.GET_PENDING, token],
    queryFn: () => getPendingProductContractApi({ token: token! }),
    enabled: Boolean(token),
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
    staleTime: 0,
  });
};
